import { el, list, mount, unmount, setAttr, setChildren } from 'redom';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import AttachmentItem from './item';

import './index.scss';

class AttachmentsPanel {

  constructor(configuration) {

    this.createAttachment = configuration.createAttachment;
    this.deleteAttachment = configuration.deleteAttachment;
    this.attachments = configuration.attachments || [];
    this.onWorking = configuration.onWorking || function noop() {};
    this.onIdle = configuration.onIdle || function noop() {};
    this.hideAttachmentsListTimer = null;
    this.outsideEditInputClickEventRegistration = null;

    this.attachmentsCount = el('#attachments-count', {
      onclick: this.showAttachmentsList.bind(this),
      // onmouseleave: this.hideAttachmentsList.bind(this)
    }, this.attachments.length);
    this.attachmentsList = list('#message-attachments-list.hide-scrollbar', AttachmentItem, '_id', this);

    this.el = el('#message-attachments-panel-main', [this.attachmentsCount]);
    this.updateList();
    this.toggleCount();

  }

  toggleCount() {

    let children = [this.attachmentsCount];

    if (this.outsideEditInputClickEventRegistration !== null) {
      children.push(this.attachmentsList);
    }

    if (this.attachments.length === 0) {
      unmount(this.el, this.attachmentsCount);
    } else {
      setChildren(this.el, children);
    }

  }

  showAttachmentsList() {

    if (this.attachments.length === 0) {
      return;
    }

    if (this.hideAttachmentsListTimer !== null) {
      clearTimeout(this.hideAttachmentsListTimer);
      return;
    }
    mount(this.el, this.attachmentsList);
    this.outsideEditInputClickEventRegistration = new OutsideClickEventRegistration(this.attachmentsList.el, this.hideAttachmentsList.bind(this));
    this.positionList();

  }

  hideAttachmentsList() {

    unmount(this.el, this.attachmentsList);
    this.outsideEditInputClickEventRegistration?.cancel();
    this.outsideEditInputClickEventRegistration = null;

  }

  open() {

    this.showAttachmentsList();

  }

  positionList() {

    setAttr(this.attachmentsList, {
      style: {
        height: 'auto'
      }
    });

    const element = this.attachmentsList.el;
    const anchorElement = this.attachmentsCount;
    const viewportElement = void 0;
    const verticalOffset = 5;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  updateList() {

    this.attachmentsList.update(this.attachments);
    this.positionList();
    this.attachmentsCount.textContent = this.attachments.length;

  }

  addFiles(files) {

    for (let file of files) {

      file.raw = true;
      file.mimetype = file.type;
      file.url = URL.createObjectURL(file);
      file._id = performance.now() + Math.random();

      this.attachments.push(file);

    }

    this.updateList();
    this.toggleCount();

    for (let index = this.attachments.length - files.length; index < this.attachments.length; index++) {
      this.attachmentsList.views[index].uploadFile();
    }

    this.open();

  }

  setByIndex(index, attachment) {
    this.attachments[index] = attachment;
    this.updateList();
  }

  deleteByIndex(index) {
    this.attachments.splice(index, 1);
    this.updateList();

    if (this.attachments.length === 0) {
      this.hideAttachmentsList();
    }

  }

  delete(attachment) {

    const index = this.attachments.indexOf(attachment);

    if (index === -1) {
      return;
    }

    this.deleteByIndex(index);
    this.deleteAttachment(attachment._id);
    this.toggleCount();

  }

  isBusy() {
    return this.attachments.some(attachment => attachment.raw === true);
  }

  tryNotifyIdle() {

    const rawAttachments = this.attachments.filter(attachment => attachment.raw === true);

    if (rawAttachments.length !== 0) {
      return;
    }

    this.onIdle();

  }

  tryNotifyWorking() {

    const rawAttachments = this.attachments.filter(attachment => attachment.raw === true);

    if (rawAttachments.length !== 1) {
      return;
    }

    this.onWorking();

  }

  update(configuration) {

    this.createAttachment = configuration.createAttachment;
    this.deleteAttachment = configuration.deleteAttachment;
    this.attachments = configuration.attachments || [];
    this.onWorking = configuration.onWorking || function noop() {};
    this.onIdle = configuration.onIdle || function noop() {};
    this.toggleCount();
    this.updateList();

  }

}

export default AttachmentsPanel;